import { render } from "./Conclusions.vue?vue&type=template&id=6653b5a9"
import script from "./Conclusions.vue?vue&type=script&lang=js"
export * from "./Conclusions.vue?vue&type=script&lang=js"

import "./Conclusions.vue?vue&type=style&index=0&id=6653b5a9&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__